import type { ConsentCookies } from '~~/types/cookies'

import dayjs from 'dayjs'

export default () => {
  const isOpen = useState('cookieConsentOpen', () => false)
  const open = () => {
    isOpen.value = true
  }

  const { public: { cookieDomain } } = useRuntimeConfig()

  const cookies = useCookie<ConsentCookies | undefined>('CookieConsent', {
    expires: dayjs().add(1, 'year').toDate(),
    path: '/',
    domain: cookieDomain && location.host.includes(cookieDomain) ? cookieDomain : undefined,
  })

  const hasConsented = computed(() => !!cookies.value && cookies.value.functionality)

  return {
    cookies,
    hasConsented,
    isOpen,
    open,
  }
}
